export function extractBoxId(text: string) {
  const m = /NM:\s*(\w+)(:?[\n|\r|;])/m.exec(text);
  if (m) {
    return m[1];
  }
}
